'use client';

import * as React from 'react';
import ApproveRejectWinnerModalContent from '@/app/dashboard/tournament/winners/components/approve-reject-winner-modal-content';
import { useAppSelector } from '@/store/hooks';
import { getUi } from '@/store/reducers/ui-slice';

import { ModalDrawer } from '@/types/general';

import { ModalLayout } from '../core/modal-layout';

export function ApproveRejectWinnerModal(): React.JSX.Element | null {
  const { modal } = useAppSelector(getUi);
  const content = modal?.content as {
    id: string;
    action: string;
  };

  return (
    <ModalLayout
      title={`${content?.action} Confirmation`}
      isOpen={modal?.open === ModalDrawer.APPROVE_REJECT_TOURNAMENT_WINNER}
    >
      <ApproveRejectWinnerModalContent />
    </ModalLayout>
  );
}
